module.exports = __webpack_public_path__ + "img/3.4388b16c.jpg";